// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal-module--root--2BEKM","backdrop":"Modal-module--backdrop--2frD7","closeIcon":"Modal-module--closeIcon--1ARYU"};